<ng-container [formGroup]="parent">
  <ng-container formGroupName="header">
    <div class="row">
      <div class="col-3 col-min-12">
        <div class="form-group has-float-label mt-2">
          <label class="form-label">Template Name</label>
          <p-select
            pInputText
            formControlName="templateId"
            (onChange)="onTemplateSelection($event)"
            [options]="templates"
            optionLabel="name"
            optionValue="id">
          </p-select>
        </div>
      </div>
      <div class="col-3 col-min-12">
        <div class="form-group has-float-label mt-2">
          <label class="form-label">PO #</label>
          <input
            class="form-control"
            type="text"
            formControlName="poNumber"
            pInputText />
        </div>
      </div>
      <div class="col-4 col-min-12 d-flex">
        <div class="mt-4 pt-3">
          <a
            class="has-link"
            *ngIf="!!poJournalPdf"
            (click)="onEmailSelection()"
            ><i class="pi pi-envelope"></i> Email</a
          >
        </div>
      </div>
    </div>
    <div class="mt-3">
      <ngx-extended-pdf-viewer
        [base64Src]="poJournalPdf"
        [textLayer]="true"
        [showHandToolButton]="true"
        [showPresentationModeButton]="true"
        height="75vh"
        [filenameForDownload]="
          'SamplePO-' + poNumber
        "></ngx-extended-pdf-viewer>
    </div>
  </ng-container>
</ng-container>
